import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { useMainContext } from 'Hooks';

const getColor = ({ color }: { color: string }): string => {
  switch (color) {
    case 'success':
      return '#1f6f78';
    case 'error':
      return '#63171B';
    default:
      return '#1f6f78';
  }
};

const getBackgroundColor = ({ color }: { color: string }): string => {
  switch (color) {
    case 'success':
      return '#93e4c1';
    case 'error':
      return '#FEB2B2';
    default:
      return '#93e4c1';
  }
};

export const Notice = (): JSX.Element => {
  const location = useLocation();
  const {
    state: {
      noticeData: { label, color },
      reset,
    },
  } = useMainContext();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsOpen(true);
    if (!label) setIsOpen(false);
    const timer = setTimeout(() => {
      setIsOpen(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [reset]);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <Container>
      <StyledNotice color={color} $isOpen={isOpen}>
        {label}
      </StyledNotice>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const StyledNotice = styled.div<{
  $isOpen: boolean;
  color: string;
}>`
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0.8rem 1.2rem;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 1rem;
  z-index: 99;
  position: absolute;
  bottom: 4rem;
  background-color: ${({ color }) => getBackgroundColor({ color })};
  color: ${({ color }) => getColor({ color })};
  ${({ $isOpen }) =>
    $isOpen
      ? css`
          opacity: 1;
          visibility: visible;
          transition: 0.3s;
        `
      : css`
          opacity: 0;
          visibility: hidden;
          transition: 0.3s;
        `}
  @media (orientation: landscape) and (min-width: 768px) {
    flex-direction: row;
  }
`;
